
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'BalanceHeader'
})
export default class extends Vue {
}
